import LxcError from "~/core/models/LxcError.class";
import type { KeystoreCertificateDetail } from "~/modules/certificate/models/KeystoreCertificateDetail.interface";
import keystoreService from "~/modules/certificate/services/keystore.service";

export function useInstantCertificateRenewCsr() {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const result: Ref<KeystoreCertificateDetail | undefined> = ref();

  async function instantRenewCertificate(alias: string) {
    isLoading.value = true;
    error.value = undefined;
    result.value = undefined;

    const response = await keystoreService.instantCertificateRenewCsr(alias);

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    instantRenewCertificate,
    isLoading,
    error,
    result,
  };
}
